import React from 'react';
import { CheckIcon } from 'lucide-react';
const includes = ['5 Módulos Maestros completos', 'Clases grabadas paso a paso', '4 Bonos exclusivos de regalo', 'Acceso inmediato en formato PDF'];
export function IncludesSection() {
  return <section className="py-10 md:py-14 px-4 bg-brand-deep" data-id="element-188">
      <div className="max-w-3xl mx-auto" data-id="element-189">
        <div className="bg-brand-navy p-8 md:p-10 rounded-3xl border border-brand-primary/30 shadow-sm" data-id="element-190">
          <h2 className="text-2xl md:text-3xl font-black text-center text-white mb-8" data-id="element-191">
            Resumen de tu acceso:
          </h2>
          <ul className="space-y-5" data-id="element-192">
            {includes.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-193">
                <div className="bg-brand-primary p-1.5 rounded-full flex-shrink-0" data-id="element-194">
                  <CheckIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-195" />
                </div>
                <span className="text-xl font-bold text-white" data-id="element-196">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}